module.exports = __webpack_public_path__ + "img/BRA.6ed3d39b.png";